/* VPV Tabs — builds an accessible tablist from opaque child panels.

   The Tab Group can't read its Tab blocks in Liquid (content_for is opaque), so
   each Tab stamps its name onto its panel (data-tab-name) and this controller
   reads the rendered panels to assemble the controls with full ARIA + keyboard.
   No JS → a <noscript> in the markup reveals all panels (no content lost). */
(function () {
  function initTabs(root) {
    if (root.dataset.vpvTabsInit) return;

    var controls = root.querySelector('.vpv-tabs__controls');
    var panelsWrap = root.querySelector('.vpv-tabs__panels');
    if (!controls || !panelsWrap) return;

    var panels = Array.prototype.filter.call(panelsWrap.children, function (el) {
      return el.classList.contains('vpv-tab-panel');
    });
    if (!panels.length) return;

    root.dataset.vpvTabsInit = '1';
    var baseId = root.id || 'vpv-tabs';
    var tabs = [];

    panels.forEach(function (panel, i) {
      var name = panel.getAttribute('data-tab-name') || ('Tab ' + (i + 1));
      var tabId = baseId + '-tab-' + i;
      var panelId = baseId + '-panel-' + i;

      panel.id = panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabId);
      panel.setAttribute('tabindex', '0');
      panel.hidden = i !== 0;

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'vpv-tabs__tab';
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.textContent = name;
      controls.appendChild(tab);
      tabs.push(tab);
    });

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        panels[i].hidden = !selected;
        if (selected && focus) tab.focus();
      });
    }

    controls.addEventListener('click', function (e) {
      var tab = e.target.closest('.vpv-tabs__tab');
      if (tab) select(tabs.indexOf(tab), false);
    });

    controls.addEventListener('keydown', function (e) {
      var current = tabs.indexOf(document.activeElement);
      if (current < 0) return;
      var last = tabs.length - 1;
      var next;
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown': next = current === last ? 0 : current + 1; break;
        case 'ArrowLeft':
        case 'ArrowUp': next = current === 0 ? last : current - 1; break;
        case 'Home': next = 0; break;
        case 'End': next = last; break;
        default: return;
      }
      e.preventDefault();
      select(next, true);
    });

    root.classList.add('vpv-tabs--ready');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vpv-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
